import {logger} from '@zoefin/logger';

import {MAX_LOG_ATTRIBUTE_LENGTH} from '../constants/request';

/** Truncates a string to the OTel attribute limit (4096 chars), appending a `[truncated]` marker. */
export const truncateForAttribute = (value: string): string => {
  if (value.length <= MAX_LOG_ATTRIBUTE_LENGTH) {
    return value;
  }

  return `${value.slice(0, MAX_LOG_ATTRIBUTE_LENGTH)}... [truncated, total ${value.length} chars]`;
};

/** `JSON.stringify` with a catch — returns `'[Unserializable]'` on circular refs or other failures. */
export const safeSerialize = (value: unknown): string => {
  if (typeof value === 'string') {
    return value;
  }

  try {
    const serialized = JSON.stringify(value);

    return serialized ?? '[Unserializable]';
  } catch (error) {
    logger.warn(
      {
        error,
      },
      'Failed to serialize request attribute',
    );

    return '[Unserializable]';
  }
};

/** Quick heuristic: returns true when the trimmed text starts with `{` or `[`, used to attempt JSON parsing on ambiguous content-types. */
export const isJsonLikeText = (value: string): boolean => {
  const trimmedValue = value.trim();

  return trimmedValue.startsWith('{') || trimmedValue.startsWith('[');
};
